<template>
  <A11yNavigationMenu />

  <main id="main-content" v-bind="$attrs">
    <slot />
  </main>
</template>

<script lang="ts" setup>
import A11yNavigationMenu from '~/components/A11yNavigationMenu/A11yNavigationMenu.vue'

defineOptions({
  inheritAttrs: false,
})
</script>
